var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"card-button",attrs:{"to":_vm.to}},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])]),_c('i',{class:'fas fa-' + _vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }